import { createActionHelpers } from 'vuex-loading';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loading',
});

const state = {
    ingredient: {
        outlet_id: null,
        measurement_id: null,
        code: null,
        name: null,
        serving_ingredients: [],
        stocks: [
            {
                stock_movement_products: [],
            },
        ],
    },
    ingredientList: [],
    originalIngredientList: [],
};

const getters = {
    ingredient: state => state.ingredient,

    ingredientList: state => state.ingredientList,

    originalIngredientList: state => state.originalIngredientList,

    servingIngredients() {
        return state.ingredient.serving_ingredients;
    },

    associatedEndProducts() {
        return state.ingredient.serving_ingredients
            .filter(serving_ingredient => {
                return !_.isNull(serving_ingredient.serving.stock);
            })
            .map(serving_ingredient => {
                let variant = serving_ingredient.serving.stock.variant;

                return {
                    code: serving_ingredient.serving.stock.product.code,
                    product: serving_ingredient.serving.stock.product.name,
                    variant: variant ? variant.name : null,
                    outlet: serving_ingredient.serving.stock.outlet.name,
                };
            });
    },

    associatedStockMovementProducts() {
        return state.ingredient.stocks
            .map(stock => {
                return stock.stock_movement_products;
            })
            .flat(1);
    },
};

const mutations = {
    setIngredient(state, data) {
        state.ingredient = data;
    },

    resetIngredient(state, outlet_id) {
        state.ingredient = {
            outlet_id,
            measurement_id: null,
            code: null,
            name: null,
            serving_ingredients: [
                {
                    serving: {
                        stock: {
                            product: {
                                code: null,
                                name: null,
                            },
                            variant: {
                                name: null,
                            },
                        },
                    },
                },
            ],
        };
    },

    setIngredientList(state, data) {
        state.ingredientList = data;
    },

    setOriginalIngredientList(state, data) {
        state.originalIngredientList = data;
    },
};

const actions = {
    async showIngredient({ commit, dispatch }, id) {
        const url = Laroute.route('franchise.inventory.ingredient.show', {
            id,
        });

        startLoading(dispatch, 'show-ingredient');

        try {
            const { data } = await axios.get(url);
            commit('setIngredient', data);
            endLoading(dispatch, 'show-ingredient');
            return data;
        } catch (e) {
            endLoading(dispatch, 'show-ingredient');
            throw e;
        }
    },

    async createIngredient({ commit, dispatch, state }) {
        const url = Laroute.route('franchise.inventory.ingredient.create');

        startLoading(dispatch, 'save-ingredient');

        let ingredient = state.ingredient;

        if (ingredient.measurement) {
            ingredient.measurement_id = ingredient.measurement.id;
        }

        try {
            await axios.post(url, ingredient);
            endLoading(dispatch, 'save-ingredient');
        } catch (e) {
            endLoading(dispatch, 'save-ingredient');
            throw e;
        }
    },

    async updateIngredient({ commit, dispatch, state }) {
        const url = Laroute.route('franchise.inventory.ingredient.update');

        startLoading(dispatch, 'save-ingredient');

        let ingredient = state.ingredient;

        if (ingredient.measurement) {
            ingredient.measurement_id = ingredient.measurement.id;
        }

        try {
            await axios.put(url, ingredient);
            endLoading(dispatch, 'save-ingredient');
        } catch (e) {
            endLoading(dispatch, 'save-ingredient');
            throw e;
        }
    },

    async getIngredientList({ commit, dispatch }, params = {}) {
        const url = Laroute.route('franchise.inventory.ingredient.list');

        startLoading(dispatch, 'fetch-ingredients');

        const options = {
            params: Object.assign(
                {
                    query: null,
                    limit: 15,
                },
                params,
            ),
        };

        try {
            const { data } = await axios.get(url, options);
            commit('setIngredientList', data.data);
            commit('setOriginalIngredientList', data.data);
            endLoading(dispatch, 'fetch-ingredients');
            return data.data;
        } catch (e) {
            endLoading(dispatch, 'fetch-ingredients');
            throw e;
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/inventory-fnb/modules/ingredient.js